import { Component, Input } from '@angular/core';
import { IContact } from '../../../../../type_definitions/datatypes';

@Component({
  selector: 'contract-agreed',
  template: `
    <p>
      <span translate>BPPROFILES.CONTRACT.AGREED_BY</span>
      <span class="margin-left-xs margin-right-xs"><contact-info [contact]="contact"></contact-info></span>
      <span [translateParams]="{ date: (agreementDate | format: 'formatDateMedium') }" translate>BPPROFILES.CONTRACT.AGREED_ON</span>
    </p>
  `
})
export class ContractAgreedComponent {
  @Input() public contact:IContact;
  @Input() public agreementDate:number;
}